// @owners { team: patients }
import { SPACING } from '@alto/design-library-tokens';
import { Column, H1, XxxlPadding } from '@alto/design-system';
import React from 'react';

/**
 * Large centered heading for the order details page.
 *
 * Shared between the loaded page and its loading state so the two render the exact same header and
 * the page doesn't change shape once the shipment arrives.
 */
export const OrderDetailsPageHeader = () => {
  return (
    <XxxlPadding
      leftPadding={SPACING.STATIC.NONE}
      rightPadding={SPACING.STATIC.NONE}
    >
      <Column centerHorizontally>
        <H1>Order details</H1>
      </Column>
    </XxxlPadding>
  );
};
